/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function SippenSauseLegal() {
  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="30vh"
        width="100%"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
          mb: 4,
        }}
      />
      <Card
        sx={{
          p: 4,
          mx: { xs: 3, lg: 6 },
          mt: 0,
          mb: 6,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MKTypography variant="h2" mb={4}>
                Datenschutz­erklärung SippenSause
              </MKTypography>
            </Grid>
            <Grid item xs={12}>
              <MKTypography variant="h3" mb={2}>
                Hinweis zur verantwortlichen Stelle
              </MKTypography>
              <MKTypography variant="h4" color="text" mb={4}>
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={0}>
                Lennart Krömer
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={4}>
                lennartkr@web.de
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={1}>
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
                gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
                personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </MKTypography>
            </Grid>
            <Grid item xs={12}>
              <MKTypography variant="h4" mb={2}>
                2. Datenerhebung
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={4}>
                Für das Spiel SippenSause werden keinerlei Daten erhoben, gespeichert oder
                weitergegeben.
              </MKTypography>
            </Grid>
            <Grid item xs={12}>
              <MKTypography variant="h4" mb={2}>
                Urheberrecht
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={4}>
                Alle Inhalte der App SippenSause sind urheberrechtlich geschützt. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
                Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des Entwicklers.
              </MKTypography>
            </Grid>
          </Grid>
        </Container>
      </Card>
      <DefaultFooter content={footerRoutes} />
    </>
  );
}

export default SippenSauseLegal;
